export enum DateFormatPreference {
  DayMonthYear = "DAY_MONTH_YEAR",
  MonthDayYear = "MONTH_DAY_YEAR",
}
